module.exports = __webpack_public_path__ + "img/farming_34.692a2c39.png";